import {
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { billRateModStyles } from './BillRateMod.styles';
import { contractTypeId, RegularRate } from 'app/models/Placement/PlacementMods';
import { isNumber } from '../../ModificationsUtils';
import { useSelector } from 'react-redux';
import { selectCurrentModDetails, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { validDecimal } from 'app/helpers/numberHelper';

export const BillRateType = ({ isExpanded }: { isExpanded: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue, setError, clearErrors } = useFormContext();

  const { classes } = billRateModStyles({ isExpanded });
  const contractType: any = useWatch({ name: contractTypeId });
  const regularRateValue: any = useWatch({ name: 'regularRate' });

  const currentModDetails = useSelector(selectCurrentModDetails);
  const isModEdit = useSelector(selectIsEditMod);
  const handleRadioChange = e => {
    const val = parseInt(e.target.value);
    setValue('contractTypeId', val);
  };
  const isValidInput = factor => {
    return isNumber(getValues(factor));
  };

  useEffect(() => {
    if (!regularRateValue && contractType === 2) {
      setError(RegularRate, { type: 'required' });
    } else {
      clearErrors(RegularRate);
    }
  }, [contractType]);
  return (
    <Grid container direction="row" xs={12} spacing={6}>
      <Grid item alignSelf="end">
        <Controller
          control={control}
          name={'contractTypeId'}
          render={({ field: { onChange, ...rest } }) => {
            return (
              <FormControl disabled={!isModEdit}>
                <div className={classes.headerLeft}>
                  <div>
                    <Typography component="span" style={{ color: 'theme.palette.system.darkGray' }}>{`${t(
                      'placement.placementMods.contractType',
                    )}`}</Typography>
                  </div>
                  <div style={{ marginTop: '-7px' }}>
                    <RadioGroup row onChange={handleRadioChange} value={contractType}>
                      <FormControlLabel control={<Radio />} label={'Flat'} value={1} className={classes.radioLabel} />
                      <FormControlLabel control={<Radio />} label={'Hourly'} value={2} className={classes.radioLabel} />
                    </RadioGroup>
                  </div>
                </div>
              </FormControl>
            );
          }}
        />
      </Grid>
      {contractType === 2 && (
        <Grid item>
          <Controller
            name={RegularRate}
            control={control}
            rules={{ required: contractType === 2 }}
            render={({ field: { onChange, value, ...rest } }) => (
              <TextField
                variant="filled"
                className={classes.rateField}
                defaultValue={regularRateValue}
                label={`${t(`placement.placementMods.${RegularRate}`)}`}
                InputLabelProps={{
                  shrink: getValues(RegularRate) ? true : false,
                }}
                value={regularRateValue}
                onChange={e => {
                  if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
                    setValue(RegularRate, e.target.value);
                    onChange(e.target.value);
                  }
                }}
                InputProps={{
                  readOnly: !isModEdit,
                  style: {
                    pointerEvents: isModEdit ? 'auto' : 'none',
                  },
                  startAdornment: (
                    <>
                      {isValidInput(RegularRate) && (
                        <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>
                      )}
                    </>
                  ),
                  sx: { fontSize: '14px' },
                }}
                {...rest}
              />
            )}
          />
        </Grid>
      )}
    </Grid>
  );
};
